import dayjs from "dayjs";

export const poColumns = [
  {
    field: "lineNo",
    headerName: "Line No",
    align: "right",
  },
  {
    field: "extPOLineNo",
    headerName: "Ext PO Line No",
    align: "right",
    left: 180,
    width: 150,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    left: 330,
    width: 200,
  },
  {
    field: "poQty",
    headerName: "PO Qty",
    // sortable: false,
    width: 80,
    align: "right",
  },
  {
    field: "poUOM",
    headerName: "PO UOM",
    // sortable: false,
    width: 100,
    // valueGetter: (col) => {
    //   return col?.value?.label ?? "";
    // },
    valuesGetter: (col) => {
      return col.label;
    },
  },
  {
    field: "qtyOrdered",
    headerName: "Qty Ordered",
    // sortable: false,
    width: 120,
    align: "right",
  },
  {
    field: "qtyReceived",
    headerName: "Qty Received",
    // sortable: false,
    width: 120,
    align: "right",
  },
  {
    field: "packType",
    headerName: "Pack Type",
    // sortable: false,
    width: 100,
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    // sortable: false,
    width: 100,
  },
  {
    field: "eta",
    headerName: "ETA",
    // sortable: false,
    width: 120,
    valuesGetter: (col) => {
      return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
    },
  },
  {
    field: "mln",
    headerName: "MLN",
    // sortable: false,
    //flex: 0.5,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    // sortable: false,
    width: 120,
    valuesGetter: (col) => {
      return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
    },
  },
];
